import * as React from "react";
import { observer } from "mobx-react";
import SeekerStore from "../../../stores/seekerStore";
import LegalStore from "../../../stores/legalStore";
import { BusyEvent } from "../../../models/enums";
import { ILocalization } from "../../../models/localization";
import { Row, Col, Grid } from "react-flexbox-grid";
import { OpportunitySummary } from "../../../models/opportunity";
import OpportunitySummaryCard from "../../opportunity/opSummary";
import Busy from "../../widgets/busy";
import * as s from "./featuredOps.css";

@observer
export default class FeaturedOps extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }
  componentWillMount(): void {
    this.props.store.opportunityStore.getFeaturedOps();
  }
  renderFeaturedOps(): JSX.Element {
    let cards: JSX.Element[] = [];
    this.props.store.opportunityStore.featuredOps.map((os: OpportunitySummary, i: number): void => {
      cards.push(<OpportunitySummaryCard key={i} store={this.props.store} op={os} />);
    });
    return <Grid className={s.grid} fluid><Row>{cards}</Row></Grid>
  }
  render(): JSX.Element {
    if (this.props.store.opportunityStore.featuredOps.length === 0) {
      return null;
    }
    const local: ILocalization = this.props.store.localization.fields;
    return (<div className={s.container}>
      <Row><h4 className={s.featureTitle}>{local.featuredOps}</h4></Row>
      {this.props.store.viewState.isBusy(BusyEvent.LoadFeaturedOps) && <Busy show={true} size="sm" />}
      {this.renderFeaturedOps()}
    </div>)
  }
}


// WEBPACK FOOTER //
// ./src/components/opportunity/featuredOps/index.tsx